// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"aca8610b","419":"8924af5d","626":"3614bc37","772":"28feade6"}[chunkId] + ".css";
};